import styles from './SettlementAutoGeneration.module.scss';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';

const SettlementAutoGeneration = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  return (
    <PrimaryTemplate
      h1={t('settlement_auto_generation.nav_label')}
      prevFunction={handleBack}
      headerSticky={true}
    >
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.iconWrapper}>
            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="32"
                cy="32"
                r="30"
                stroke="#4A90D9"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M20 34L28 42L44 22"
                stroke="#4A90D9"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
                strokeDashoffset="0"
              >
                <animate
                  attributeName="stroke-dashoffset"
                  from="60"
                  to="0"
                  dur="1s"
                  fill="freeze"
                />
              </path>
            </svg>
          </div>
          <h1 className={styles.title}>
            {t('settlement_auto_generation.title')}
          </h1>
          <p className={styles.subtitle}>
            {t('settlement_auto_generation.subtitle')}
          </p>
          <div className={styles.divider} />
          <p className={styles.description}>
            {t('settlement_auto_generation.description')}
          </p>
          <a href="mailto:info@recotech.co.jp" className={styles.emailLink}>
            ✉ info@recotech.co.jp
          </a>
          <p className={styles.footer}>
            {t('settlement_auto_generation.footer')}
          </p>
        </div>
      </div>
    </PrimaryTemplate>
  );
};

export default SettlementAutoGeneration;
